
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#078930","d":"M0 0h20v10H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h20v7H0z"}}),_c('path',{attrs:{"d":"M0 0h20v3H0z"}}),_c('path',{attrs:{"fill":"#DA121A","d":"M0 3.5h20v3H0z"}}),_c('path',{attrs:{"fill":"#0F47AF","d":"M0 0l8.66 5L0 10z"}}),_c('path',{attrs:{"fill":"#FCDD09","d":"M1.287 5l2.894.94-1.789-2.462v3.044l1.79-2.462z"}})])
          )
        }
      }
    